import React, { Component } from 'react';

class HowItWorks extends Component {
    render() {
        return (
            <div>
                <section id="steps">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                <h2 className="section-title">How it Works in 3 <span className="color-text">Easy</span> Steps </h2>
                                <p className="section-tagline">
                                    synthCity lets you get presets for your favorite virtual synth! <br /> Just search!
                                </p>
                            </div> {/* END col-12*/}
                        </div> {/* END row*/}
                        <div className="row">
                            <div className="col-lg-4 col-md-7 text-center mt-30 wow fadeInLeft" data-wow-delay=".1s">
                                <div className="steps-block">
                                    <div className="step-iocn bg-yellow">
                                        <span className="icon icon-idea2" />
                                        <div className="step-count">1</div>
                                    </div>
                                    <h4 className="block-title">
                                        Search It
                                    </h4>
                                    <p>
                                        Heard an amazing synth but don't know how to reproduce it? Search the collection of synth presets that only keeps growing!
                                    </p>
                                </div> {/* END steps-block*/}
                            </div> {/*END col-lg-3 col-md-6*/}
                            <div className="col-lg-4 col-md-7 text-center mt-30 wow fadeIn" data-wow-delay=".2s">
                                <div className="steps-block">
                                    <div className="step-iocn bg-theme">
                                        <span className="icon icon-chat" />
                                        <div className="step-count">2</div>
                                    </div>
                                    <h4 className="block-title">
                                        Request Synth Recipes
                                    </h4>
                                    <p>
                                        Don't know how to make a sound? Post a request and let Synth Gods of the community help!
                                    </p>
                                </div> {/* END steps-block*/}
                            </div> {/*END col-lg-3 col-md-6*/}
                            <div className="col-lg-4 col-md-7 text-center mt-30 wow fadeInRight" data-wow-delay=".3s">
                                <div className="steps-block">
                                    <div className="step-iocn bg-light-green">
                                        <span className="icon icon-correct" />
                                        <div className="step-count">3</div>
                                    </div>
                                    <h4 className="block-title">
                                        Practice Sound Design
                                    </h4>
                                    <p>
                                        Need to practice sound design? Improve by solving community created challenges.
                                    </p>
                                </div> {/* END steps-block*/}
                            </div> {/*END col-lg-3 col-md-6*/}
                            {/*
                            <div className="col-lg-3 col-md-6 text-center mt-30 wow fadeInRight" data-wow-delay=".4s">
                                <div className="steps-block">
                                    <div className="step-iocn bg-light-red">
                                        <span className="icon icon-correct" />
                                        <div className="step-count">4</div>
                                    </div>
                                    <h4 className="block-title">
                                        Eat
                                    </h4>
                                    <p>
                                        Most humans require sustenance. You should really eat something.
                                    </p>
                                </div>
                            </div> 
                            */}
                        </div> {/* END row*/}
                    </div> {/* END container*/}
                </section> {/* END steps*/}
            </div>
        );
    }
}

export default HowItWorks;


// WEBPACK FOOTER //
// ./src/components/synthcity/landing/HowItWorks.js